import React from "react";
import { NoticesAndWarnings } from "./ProductDetailPageResult";

interface Props {
  isCommonCarrier: boolean;
  noticesAndWarnings: NoticesAndWarnings;
  showEverlivingProductPage: boolean;
}

const ProductNoticesAndWarnings = ({
  isCommonCarrier,
  noticesAndWarnings,
  showEverlivingProductPage,
}: Props) => {
  return (
    <>
      {noticesAndWarnings?.hasCompatibilityWarning && (
        <p>
          <b>
            Please check the Compatibility resource for information on items
            that work with this product.
          </b>
        </p>
      )}
      {noticesAndWarnings?.hasSubstituteItemWarning && (
        <p>
          <i>Due to the universal nature of this product, source may vary.</i>
        </p>
      )}
      {isCommonCarrier && !showEverlivingProductPage && (
        <p className="prodDetailText_commonCarrier">
          <b>This Item Ships via Common Carrier.</b> For more information and
          tips to help your delivery go smoothly, click{" "}
          <a
            href="/services/liftgate/"
            target="_blank"
            data-testid="liftgate-link"
            className="underline text-green-500"
          >
            here.
          </a>
        </p>
      )}
      {noticesAndWarnings?.hasORMD && !showEverlivingProductPage && (
        <p>
          Due to US DOT shipping regulations, we are unable to ship this product
          to Alaska, Hawaii, and international destinations. It is also
          ineligible for next day or second day shipping and cannot be returned.
          Please contact Customer Solutions prior to placing your order if you
          have any questions or concerns.
        </p>
      )}
      {noticesAndWarnings?.isHazardousProduct && !showEverlivingProductPage && (
        <p>
          This product is considered hazardous under US DOT shipping
          regulations. Due to the hazardous shipping restrictions, this item
          requires a signature for delivery and cannot be returned. We are
          unable to ship this product to Alaska, Hawaii, and international
          destinations. It is also ineligible for next day or second day
          shipping. Please contact Customer Solutions prior to placing your
          order if you have any questions or concerns.
        </p>
      )}
      {noticesAndWarnings?.isSpecialOrder && !showEverlivingProductPage && (
        <p data-testid="notices-warnings-special-order">
          Because this item is not stocked in our warehouse, processing, transit
          times and stock availability will vary. If you need your items by a
          certain date, please contact us prior to placing your order. Expedited
          shipping availability may vary. We cannot guarantee that this item can
          be cancelled off of the order or returned once it is placed.
        </p>
      )}
      {noticesAndWarnings?.hasSerialNumberWarning &&
        !showEverlivingProductPage && (
          <p>
            At checkout, you will be prompted to provide the model and serial
            number for this item. While omitting this information will not
            prevent you from placing your order, we may need to contact you
            afterward to obtain it and complete your shipment as the
            manufacturer requires this information. Providing this information
            at checkout will help ensure your order is processed smoothly. We
            cannot guarantee that such information will be used to verify
            compatibility with your model. Please use resources such as the
            Compatible Models table on our product pages, a service technician,
            and/or relevant product literature to ensure compatibility before
            ordering.
          </p>
        )}
    </>
  );
};

export default ProductNoticesAndWarnings;
